(() => {
  'use strict';
  const root = document.querySelector('[data-r3-product-cinematic][data-product-handle="nac"]');
  const experience = root && root.querySelector('[data-r3-nac-scroll-experience]');
  const video = experience && experience.querySelector('[data-r3-nac-scroll-video]');
  if (!experience || !video) return;
  const sticky = experience.querySelector('.r3pp__scroll-sticky');
  const antioxidant = experience.querySelector('[data-r3-nac-antioxidant-copy]');
  const respiratory = experience.querySelector('[data-r3-nac-respiratory-copy]');
  const recovery = experience.querySelector('[data-r3-nac-recovery-copy]');
  const ingredients = experience.querySelector('[data-r3-nac-ingredients]');
  let ready = false, raf = 0, start = 0, range = 1, last = -1, retries = 0, retryTimer = 0;
  const sources = Array.from(video.querySelectorAll('source')).map(el => ({src: el.getAttribute('src'), media: el.getAttribute('media')}));
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const toggle = (el, visible) => { if (!el) return; el.classList.toggle('is-visible', visible); el.setAttribute('aria-hidden', String(!visible)); };
  function measure() {
    const rect = experience.getBoundingClientRect();
    start = window.scrollY + rect.top;
    range = Math.max(1, experience.offsetHeight - window.innerHeight);
    schedule();
  }
  function sync() {
    raf = 0;
    const progress = clamp((window.scrollY - start) / range, 0, 1);
    const inside = window.scrollY >= start && window.scrollY <= start + range;
    sticky.classList.toggle('is-active', inside);
    sticky.classList.toggle('is-ended', window.scrollY > start + range);
    const t = Math.min(1, progress + .002);
    const phone = window.matchMedia('(max-width: 749px)').matches;
    if (phone) {
      /* Four equal phone segments across the complete scroll experience. */
      toggle(antioxidant, t >= .072 && progress < .25);
      toggle(respiratory, progress >= .25 && progress < .50);
      toggle(recovery, progress >= .50 && progress < .75);
      toggle(ingredients, progress >= .75);
    } else {
      toggle(antioxidant, t >= .25);
      toggle(respiratory, t >= .50);
      toggle(recovery, t >= .75);
      toggle(ingredients, t >= .50);
    }
    if (!ready) return;
    const duration = Number.isFinite(video.duration) ? video.duration : 7.366667;
    const target = progress === 1 ? duration : progress * duration;
    if (Math.abs(target - last) < .002) return;
    last = target;
    video.pause();
    try { video.currentTime = target; } catch (_) {}
  }
  function schedule() { if (!raf) raf = requestAnimationFrame(sync); }
  function frameReady() { if (video.readyState >= 2) video.classList.add('is-frame-ready'); }
  function armRetry() {
    clearTimeout(retryTimer);
    if (!video.classList.contains('is-frame-ready') && retries < 3) retryTimer = setTimeout(retryLoad, 5000);
  }
  function retryLoad() {
    if (video.readyState >= 2 || retries >= 3) return frameReady();
    retries += 1;
    const chosen = sources.find(({media}) => media && window.matchMedia(media).matches) || sources.find(({media}) => !media) || sources[0];
    video.src = chosen.src + (chosen.src.includes('?') ? '&' : '?') + 'r3retry=' + retries;
    try { video.load(); } catch (_) {}
    armRetry();
  }
  function metadata() { ready = Number.isFinite(video.duration) && video.duration > 0; video.pause(); measure(); armRetry(); }
  video.muted = true; video.defaultMuted = true; video.playsInline = true; video.autoplay = false; video.loop = false; video.controls = false; video.pause();
  window.addEventListener('scroll', schedule, {passive:true});
  window.addEventListener('resize', measure, {passive:true});
  window.addEventListener('orientationchange', measure, {passive:true});
  window.addEventListener('load', measure, {once:true});
  video.addEventListener('loadedmetadata', metadata, {once:true});
  video.addEventListener('durationchange', metadata);
  video.addEventListener('loadeddata', frameReady);
  video.addEventListener('seeked', frameReady);
  video.addEventListener('canplay', schedule);
  video.addEventListener('error', retryLoad);
  video.addEventListener('stalled', armRetry);
  video.addEventListener('play', () => video.pause());
  document.addEventListener('visibilitychange', () => { if (!document.hidden && video.readyState < 2) retryLoad(); });
  if ('ResizeObserver' in window) new ResizeObserver(measure).observe(experience);
  if (video.readyState >= 1) metadata(); else { video.load(); armRetry(); }
  measure();
})();
